import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Button, IconButton, Modal, Tooltip } from '@mui/material';
import './styles.scss';
import _ from "lodash";
import { TextField } from '@material-ui/core';
import { deleteStory, getStory, getStoryAsLazy, localState } from '../../../redux/actions/buddyBooks';
import { Close } from '@mui/icons-material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 3,
    outline: 'none',
    boxShadow: 24,
};

const closeButton = {
    largeIcon: {
        width: 30,
        height: 30,
        position: 'absolute',
        top: '10px',
        right: '10px',
    },
};

let searchTimer;

function SearchBar({ story, fullStory, openSearchBar, closeSearchBar, jumpToSection, bookId, dispatch }) {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchTextArr, setSearchTextArr] = useState(null);
    const [storyReady, setStoryReady] = useState(false);
    const [isResultPending, setIsResultPending] = useState(false);
    const [searchedSectionToJump, setSearchedSectionToJump] = useState(false);

    const firstUpdate = useRef(false);

    useEffect(() => {
        openSearchBar(setOpen);
        if (_.isEmpty(fullStory)) {
            dispatch(getStory(bookId));
        } else {
            setStoryReady(true);
        }
    }, []);

    useEffect(() => {
        if (firstUpdate.current && !_.isEmpty(story)) {
            dispatch(localState({ isSkipStoryUpdated: true, isSkippedToSearch: true }));
            jumpToSection(searchedSectionToJump);
            handleClose();
        }
        firstUpdate.current = true;
    }, [story]);

    useEffect(() => {
        !_.isEmpty(fullStory) && setStoryReady(true);
    }, [fullStory]);

    const handleClose = () => {
        closeSearchBar(setOpen);
    };

    const handleSearchText = (e) => {
        clearTimeout(searchTimer);
        setSearchText(e.target.value);
        let searchVal = e.target.value && e.target.value.toLowerCase();
        if (searchVal.trim() && storyReady) {
            setIsResultPending(true)
            searchTimer = setTimeout(() => {
                console.log("set time called");
                let searchedSegments = fullStory && fullStory.storySegmentDto && fullStory.storySegmentDto.filter(item => {
                    let text = item.text && item.text.toLowerCase();
                    text = text.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()"]/g, "");
                    let reg = new RegExp(searchVal, "gi");
                    return text.match(reg);
                });
                if (searchedSegments) {
                    setSearchTextArr(searchedSegments);
                    setIsResultPending(false);
                }
                console.log("searchedSegments", searchedSegments, isResultPending);
            }, 1000);
        } else {
            setSearchTextArr([]);
        }

    };

    const handleJumpSection = (item) => {
        let nextIndex;
        const { storySegmentDto } = fullStory;

        let groupNumber;
        if (item?.type === "Computer") {
            groupNumber = item.groupNumber;
        } else {
            groupNumber = item.groupNumber - 1;
        }

        let indexFound = false;
        if (storySegmentDto) {
            storySegmentDto.forEach(group => {
                if (group.groupNumber === groupNumber && !indexFound) {
                    nextIndex = group.section;
                    indexFound = true;
                }
            });

            dispatch(localState({ isSkippedToSearch: true }));
            // dispatch(deleteStory());
            dispatch(getStoryAsLazy(bookId, groupNumber - 100, 200));
            localStorage.setItem("current_section", JSON.stringify({ id: bookId, section: nextIndex }));
            setSearchedSectionToJump(nextIndex);
            // jumpToSection(nextIndex);
            // handleClose();
        }
    };

    const makeBold = (item, keyword) => {
        var re = new RegExp(keyword, 'gi')
        return (
            item.replace(re, '<b>' + keyword + '</b>')
        )
    }

    const displaySearchContent = () => {
        let searchVal = searchText.trim();
        if (searchVal && isResultPending && _.isEmpty(searchTextArr)) {
            return <div className='loader'></div>
        }
        if (searchVal && !_.isEmpty(searchTextArr)) {
            return (searchTextArr.map((item, index) => {
                return (
                    <div className='search_content_grid' style={index % 2 === 0 ? { background: '#ddd' } : { background: '#aaa' }}>
                        <div
                            className='search_content'
                            title={item.text}
                            dangerouslySetInnerHTML={{ __html: makeBold(item.text, searchVal) }}
                        >
                        </div>
                        <div className='jumpBtnWrapper'>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={() => { handleJumpSection(item) }}
                            >
                                Jump To
                            </Button>
                        </div>
                    </div>
                )
            }))
        }

        if (searchVal && _.isEmpty(searchTextArr)) {
            return <div className='empty_content_box'>No matches found </div>
        } else {
            return <div className='empty_content_box'> Search by typing above... </div>
        }
        return null;
    }

    console.log("searchTextArr", searchTextArr);
    return (
        <Modal
            open={open}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box sx={style} className='search_modal'>
                <IconButton
                    variant="contained"
                    onClick={handleClose}
                    style={closeButton.largeIcon}
                    className='closeBtnIcon'
                >
                    <Tooltip title="Close" className="search_close_tooltip">
                        <Close className="search_close_icon" />
                    </Tooltip>
                </IconButton>
                <div className='search_bar_input'>
                    <TextField
                        type="text"
                        id="search"
                        name="search"
                        autoFocus={true}
                        color='primary'
                        variant="outlined"
                        placeholder='Please Enter Search Here'
                        autoComplete='off'
                        value={searchText}
                        onChange={handleSearchText}
                    />
                </div>
                <div className='search_content_box'>
                    {storyReady ?
                        displaySearchContent() :
                        <>
                            <div className='empty_content_box'>Please wait while we load your story...</div>
                            <div className='loader'></div>
                        </>
                    }
                </div>
            </Box>
        </Modal>
    )
}

const mapState = ({ platform: { story, fullStory } }) => {
    return {
        story,
        fullStory
    }
};

export default connect(mapState)(SearchBar);